import angular from 'angular';

import Component from './form-label-error.component';

const FormLabelErrorModule = angular
    .module('control-room.commons.form.component.form-label-error', [])
    .component('crFormLabelError', Component);

export default FormLabelErrorModule;
